/* eslint-disable */
/* tslint:disable */
// @ts-ignore
export default {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M24.05 0c-13.234 0-24 10.766-24 24s10.766 24 24 24 24-10.766 24-24-10.766-24-24-24zm0 42.891C13.627 42.891 5.159 34.423 5.159 24S13.627 5.109 24.05 5.109 42.941 13.577 42.941 24 34.473 42.891 24.05 42.891z"/><path pid="1" d="M12.681 21.486h22.636v5.039H12.681z" fill-rule="nonzero"/>'
}
